import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Skeleton } from '@mui/material';
import { Root, classes } from './DispensingTableSkeleton.styles';
export const DispensingTableSkeleton = memo(() => (_jsx("div", { style: { marginTop: 8 }, children: [...Array(10)].map((_, index) => (_jsxs(Root, { className: classes.container, children: [_jsx(Skeleton, { variant: 'circular', width: 50, height: 50 }), _jsx(Skeleton, { animation: 'wave', height: 50, width: '90%' })] }, index))) })));
